import { render } from "./PromptManagementTemplates.vue?vue&type=template&id=45470dce&scoped=true"
import script from "./PromptManagementTemplates.vue?vue&type=script&lang=js"
export * from "./PromptManagementTemplates.vue?vue&type=script&lang=js"

import "./PromptManagementTemplates.vue?vue&type=style&index=0&id=45470dce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45470dce"]])

export default __exports__